import { WebviewTenant } from '@enums/webview-tenant'

export const TenantActionValue = {
  [WebviewTenant.ACKODRIVE]: {
    background_color: '#1E1E1E',
    back_button_color: '#FFFFFF',
  },
}
